import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";

import { links } from "../devdata/constants/links.tsx";

interface SideMenuContextType {
  sideMenuVisible: boolean;
  currentContent: links;
  loading: boolean;
  live: boolean;
  errorshow: boolean;
  errorMessage: string;
  setloading: (val: boolean) => void;
  setlive: (val: boolean) => void;
  setCurrentContent: (val: links) => void;
  setSideMenuVisible: (val: boolean) => void;
  setErrorshow: (error: boolean) => void;
  setErrorMessage: (errormess: string) => void;
}

const SideMenuContext = createContext<SideMenuContextType | undefined>(
  undefined
);

export const SideMenuProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [sideMenuVisible, setSideMenuVisible] = useState(false);
  const [currentContent, setCurrentContent] = useState<links>(links.Hero);
  const [loading, setloading] = useState(false);
  const [live, setlive] = useState(false);
  const [errorshow, setErrorshow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const getISTTime = () => {
    const now = new Date();
    now.setHours(now.getHours() + 5, now.getMinutes() + 30); // Convert to IST
    return now;
  };

  const isMarketOpen = () => {
    const nowIST = getISTTime();
    const hours = nowIST.getHours();
    const minutes = nowIST.getMinutes();

    return (
      (hours > 9 || (hours === 9 && minutes >= 15)) &&
      (hours < 15 || (hours === 15 && minutes <= 30))
    );
  };

  useEffect(() => {
    setlive(isMarketOpen());
  }, [live]);

  return (
    <SideMenuContext.Provider
      value={{
        errorshow,
        errorMessage,
        loading,
        live,
        sideMenuVisible,
        currentContent,
        setlive,
        setloading,
        setSideMenuVisible,
        setCurrentContent,
        setErrorshow,
        setErrorMessage,
      }}
    >
      {children}
    </SideMenuContext.Provider>
  );
};

export const useSideMenu = () => {
  const context = useContext(SideMenuContext);
  if (context === undefined) {
    throw new Error("useSideMenu must be used within a SideMenuProvider");
  }
  return context;
};
